// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f62c46fc","402":"71dc7ff5","626":"63047dc1","629":"9c1ec275","868":"b1e2659e","991":"cda813f4"}[chunkId] + ".chunk.js";
};